import React from 'react'
import { BaseCard, CardField } from 'components'

export const CardLocal = (props) => {
  const { local, handleClick } = props

  return (
    local ? (
      <BaseCard
        avatar="LOCAL"
        title="Local"
        onClick={() => handleClick(local.id)}
        onNovaAba={() => handleClick(local.id, true)}
      >
        <CardField label="Endereço" value={`${local.rua}${local.numero ? `, ${local.numero}` : ''}`} />
        <CardField label="Cidade" value={local.cidade} />
        <CardField label="Bairro" value={local.bairro || 'não definido'} />
      </BaseCard>
    ) : null
  )
}
